import { Pipe, PipeTransform } from '@angular/core';
import { MetaTagsService } from 'src/app/services/meta-tags.service';
import { Location } from '@angular/common';

@Pipe({
  name: 'mailTo'
})
export class MailToPipe implements PipeTransform {

  constructor(
    private MetaTagsService: MetaTagsService,
    private location: Location
  ) { 
    
  }

  transform(link: string, metaData: any): string {
    const pageMetaData = this.MetaTagsService.getPageMetaTags();
    return encodeURI(`mailto:?body=${pageMetaData?.url}&subject=qjet`);
    
  }

}
